/**
 * The rebuilt API area (DSH-842) ships next to the legacy one instead of
 * replacing it. Set to false to take it out of the sidebar; the route stays
 * registered, so anyone with the link keeps reaching it.
 */
export const SHOW_API_CONSOLE_IN_SIDEBAR = true;
